import type { Model } from '@patsnap/tahiti-core';
import type { FeatureLocatedState } from '../types';

export const FeatureLocatedModel = Symbol.for('FeatureLocatedModel');

export interface FeatureLocatedModel extends Model<FeatureLocatedState> {}
